<jni-move-to-freight
  [(display)]="display"
  [brandingConsultantID]="bcledgerFilter?.BrandingConsultantID || ''"
  [freightSelected]="miscSelected"
  (moveToFreightEvent)="moveToFreightStatus($event)"
  *ngIf="display"></jni-move-to-freight>

<div
  class="d-flex justify-content-between align-items-center globalborder-btm-header pb-3 pt-2 px-3">
  <h2 class="mb-0">Misc. Costs</h2>
  <div class="bcledger-panel d-flex justify-content-between ms-2 me-auto">
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div class="user-panel col-auto d-flex justify-content-between">
    <div class="d-flex align-items-center gap-3">
      <p-button
        label="Export Excel"
        variant="outlined"
        icon="pi pi-cloud-upload"
        severity="secondary"
        (click)="exportExcelFile()"
        class="fullwdth secondary-btn" />
      <p-button label="Clear Filters" (click)="clearTable(dt)" />
      <span class="cross-border" (click)="onCloseModalEvent()"
        ><i class="pi pi-times"></i
      ></span>
    </div>
  </div>
</div>

<p-table
  #dt
  stripedRows
  [scrollable]="true"
  scrollHeight="calc(100vh - 265px)"
  [size]="'small'"
  [resizableColumns]="true"
  [rows]="20"
  responsiveLayout="scroll"
  [value]="miscLists"
  [(selection)]="miscSelected"
  selectionMode="single"
  [rowHover]="true"
  [rows]="20"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 20, 50, 1000]"
  [paginator]="miscLists.length >= 20 ? true : false"
  styleClass="table-listing p-head-pad p-datatable-customers">
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center">
      <ng-container *ngIf="miscLists?.length">
        <!-- <button
          type="button"
          class="btn btn-primary me-2"
          (click)="clearTable(dt)">
          Clear Filters
        </button> -->
        <div
          class="form-group has-float-label me-2 d-flex gap-2 align-items-center">
          <label class="form-label" for="total">Total</label>
          <input
            jniAutoCompleteBlocker
            class="form-control filter me-2 text-end"
            type="text"
            pInputText
            [value]="total | number: '1.2-2'"
            disabled
            *ngIf="total" />
        </div>
        <p-button
          (onClick)="moveToFreight()"
          *ngIf="miscSelected?.CategoryID?.toLowerCase() === 'misc'"
          [label]="'Move to freight'" />
      </ng-container>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 6rem" pSortableColumn="Date">
        Date
        <p-sortIcon field="Date"></p-sortIcon>
        <p-columnFilter type="text" field="Date" display="menu">
        </p-columnFilter>
      </th>
      <th pSortableColumn="ProjectName">
        Project name
        <p-sortIcon field="ProjectName"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="ProjectName"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="Description">
        Description
        <p-sortIcon field="Description"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="Description"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="CategoryID">
        Category ID
        <p-sortIcon field="CategoryID"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="CategoryID"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="AmountinTransactionCurrency">
        Amount in transaction
        <p-sortIcon field="AmountinTransactionCurrency"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="AmountinTransactionCurrency"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="MovetoFreightSalesId">
        Moved to freight sales ID
        <p-sortIcon field="MovetoFreightSalesId"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="MovetoFreightSalesId"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="OriginReferenceID">
        Original reference
        <p-sortIcon field="OriginReferenceID"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="OriginReferenceID"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="VendInvoiceID">
        Invoice
        <p-sortIcon field="VendInvoiceID"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="VendInvoiceID"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="CreatedDateTime">
        Created date and time
        <p-sortIcon field="CreatedDateTime"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="CreatedDateTime"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="CreatedBy">
        Created by <p-sortIcon field="CreatedBy"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="CreatedBy"
          display="menu"></p-columnFilter>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-miscList let-rowIndex="rowIndex">
    <tr
      class="p-selectable-row"
      [pSelectableRow]="miscList"
      [pSelectableRowIndex]="rowIndex">
      <td>{{ miscList.Date | date: "MM-dd-yyyy" }}</td>
      <td>{{ miscList.ProjectName }}</td>
      <td>{{ miscList.Description }}</td>
      <td>{{ miscList.CategoryID }}</td>
      <td>{{ miscList.AmountinTransactionCurrency | number }}</td>
      <td>{{ miscList.MovetoFreightSalesId }}</td>
      <td>{{ miscList.OriginReferenceID }}</td>
      <td>
        <a
          *ngIf="miscList.InvoiceURL"
          [href]="miscList.InvoiceURL"
          target="_blank"
          rel="noopener noreferrer">
          {{ miscList.VendInvoiceID }}
        </a>
        <span *ngIf="!miscList.InvoiceURL">{{ miscList.VendInvoiceID }}</span>
      </td>
      <td>
        <span *ngIf="miscList?.CreatedDateTime | hidedynamicsdate">
          {{ miscList.CreatedDateTime | date: "MM-dd-yyyy" }}</span
        >
      </td>
      <td>{{ miscList.CreatedBy }}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="20">No misc. costs found.</td>
    </tr>
  </ng-template>
</p-table>
